import React from 'react'
import Linkify from 'react-linkify/dist/components/Linkify'
import { AnchorLink } from '../style'
import PropTypes from 'prop-types'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { usePIP } from '../../../hooks/usePIP'
import { useDispatch } from 'react-redux'
import { setRedirectDialog } from '../../../reducers/uiSlice'
import { useTranslation } from 'react-i18next'

const MessageWithLink = ({ children, isDesktop, logType }) => {
  const { t } = useTranslation()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { setEnabled, isEnabled, canPIP } = usePIP()
  const dispatch = useDispatch()

  const handleClickUrlInChat = (e) => {
    e.preventDefault()
    if (!isEnabled && canPIP) {
      dispatch(
        setRedirectDialog({
          paymentGateway: null,
          orderData: null,
          externalUrl: e.currentTarget.href,
          showDialog: true,
          title: t('dialogs.redirectToLink'),
        }),
      )
      setEnabled(true)
    } else {
      window.open(e.currentTarget.href, '_blank')
    }
    postHogTrackEvent(logType)
  }

  const getTruncatedUrl = (url) => {
    if (url.length > 85) {
      const start = url.substring(0, 40)
      const end = url.substring(url.length - 40)
      return `${start}[...]${end}`
    }

    return url
  }

  return (
    <Linkify
      componentDecorator={(decoratedHref, decoratedText, key) => {
        return (
          <AnchorLink
            target="_blank"
            href={decoratedHref}
            key={key}
            isDesktop={isDesktop}
            rel="noreferrer"
            onClick={handleClickUrlInChat}
          >
            {getTruncatedUrl(decoratedText)}
          </AnchorLink>
        )
      }}
    >
      {children}
    </Linkify>
  )
}
MessageWithLink.propTypes = {
  children: PropTypes.element,
  isDesktop: PropTypes.bool,
  logType: PropTypes.string,
}
export default MessageWithLink
